import { Component } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { BehaviorSubject, combineLatest, Observable } from 'rxjs'
import { fromPromise } from 'rxjs/internal-compatibility'
import { map, switchMap } from 'rxjs/operators'
import { Employee, EmployeePaginatedList } from '../../../api/models/employee.model'
import { EmployeeService } from '../../../api/services/employee.service'
import { EmployeeFilterService } from '../../common/services/employee-filter.service'
import { Utils } from '../../common/utils/utils'

@Component({
    selector: 'ppw-employee-filter',
    templateUrl: './employee-filter.component.html',
    styleUrls: ['./employee-filter.component.scss']
})
export class EmployeeFilterComponent {
    trackBy = Utils.trackByIndex
    employeeControl: UntypedFormControl = new UntypedFormControl('')

    allEmployees$: Observable<Array<Employee>> = this.employeeService.reload$.pipe(
        switchMap(() => fromPromise(this.employeeService.getAllEmployees())),
        map((paginatedList: EmployeePaginatedList) => paginatedList.items.sort(Employee.fullNameCompareFn))
    )
    employeeFilter$: BehaviorSubject<string> = new BehaviorSubject<string>('')
    filteredEmployees$: Observable<Array<Employee>> = combineLatest([this.allEmployees$, this.employeeFilter$]).pipe(
        map(([allEmployees, textFilter]) => {
            const filteredEmployees = allEmployees.filter(
                (employee: Employee) =>
                    employee && employee.fullName && employee.fullName.toLowerCase().includes(textFilter.toLowerCase())
            )

            // When a full match is found on a name, this employee should automatically be selected.
            const selectedEmployee = allEmployees.find((e) => (textFilter ? e.fullName === textFilter : false))
            if (selectedEmployee) {
                this.employeeFilterService.setEmployee(selectedEmployee)
            } else {
                this.employeeFilterService.setEmployee(undefined)
            }

            return filteredEmployees
        })
    )

    constructor(
        private readonly employeeService: EmployeeService,
        private readonly employeeFilterService: EmployeeFilterService
    ) {}

    clearEmployee(): void {
        this.employeeControl.setValue('')
    }

    isEmployeeSelected(): boolean {
        return this.employeeControl.value !== ''
    }
}
